import React from "react";
import { useLang } from "./LanguageProvider";
import { ArrowUp } from "lucide-react";
import { CATALOGUE_URL, CONTACT_EMAIL } from "@/lib/siteConfig";

const LOGO_URL = "/logo/flowwhite-logo-dark.png";

export default function Footer() {
  const { t, isRtl } = useLang();

  const year = new Date().getFullYear();

  const linksSite = [
    { id: "investor", key: "about" },
    { id: "factory", key: "factory" },
    { id: "compare", key: "compare" },
    { id: "projects", key: "projects" },
    { id: "certifications", key: "certifications" },
  ];

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-brand-navyDeep border-t border-white/10 pt-20 pb-10"
    >
      <div className="container mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="FlowWhite" className="h-16 md:h-20 w-auto mb-7" />
            <p className={`text-white/60 text-sm md:text-base leading-relaxed max-w-sm ${isRtl ? "text-right" : "text-left"}`}>
              {t.footer.tagline}
            </p>
            <div className="mt-7 text-[10px] uppercase tracking-[0.22em] text-white/30">
              {t.footer.legal_name}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brand-teal font-semibold mb-5">
              {t.footer.links_title}
            </div>
            <ul className="-my-1.5">
              {linksSite.map((l) => (
                <li key={l.id}>
                  <a
                    href={`#${l.id}`}
                    data-testid={`footer-link-${l.id}`}
                    className="block py-1.5 text-sm text-white/70 hover:text-white transition-colors"
                  >
                    {t.nav[l.key]}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={CATALOGUE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-catalogue"
                  className="block py-1.5 text-sm text-white/70 hover:text-white transition-colors"
                >
                  {t.nav.catalogue}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] uppercase tracking-[0.22em] text-brand-teal font-semibold mb-5">
              {t.footer.contact_title}
            </div>
            <div className="space-y-2 text-sm text-white/70">
              <div>{t.contact.address.line}</div>
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="block hover:text-white transition-colors"
                data-testid="footer-email"
              >
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="text-xs text-white/35">
            © {year} FlowWhite. {t.footer.rights}
          </div>
          <button
            onClick={goTop}
            data-testid="back-to-top"
            className="group inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-white/50 hover:text-white transition-colors"
          >
            <ArrowUp size={14} className="transition-transform group-hover:-translate-y-0.5" />
            {t.common.back_to_top}
          </button>
        </div>
      </div>
    </footer>
  );
}
